import {createApp} from 'vue';
import store from './store';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import App from './components/App.vue';
// Routes
import router from './router';

require('./bootstrap');
require('@popperjs/core');

// Iniciamos vue con un HTML (componente) basico
const app = createApp(App);

app.provide('_csrf_token', window._csrf_token);
app.provide('_user_token', window._user_token);

app.use(router);
app.use(store);
app.use(Toast)

// Busca el div con id #app
app.mount('#app');
